export const cleanArray = (arr) => arr.filter(v => v !== '')
